import React, { useEffect, useState } from "react";
import {
  getFormContent,
  getSingleSurvey,
  updateFormContent,
  surveyResultPreview,
  sharePreviewLink,
  addFormContent,
  imageUpload,
} from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import { useNavigate } from "react-router-dom";
import { Button, Snackbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../api/config/apiConfig";
import ContactDetailField from "../../molecules/ContactDetailField";
import Input from "../../atoms/Input";
import DynamicText from "../../molecules/DynamicText";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import { useParams } from "react-router-dom";
import PrintComponent from "../PrintComponent";
import AcknowledgementReceiptDownload from "./ClientSide/download";
import TextArea from "../../atoms/Textarea";
import moment from "moment";
import ShareWithClientsModal from "../../molecules/ShareWithClients";
import { sendSuperAdminVerificationForEdit } from "../PrebidAgreement/creation/service";
import SuperAdminVerifationModal from "../../molecules/SuperAdminVerifationModal";
import MySignatureCanvas from "../../molecules/signature_canvas";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import ShareIcon from "@mui/icons-material/Share";
import PrintIcon from "@mui/icons-material/Print";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentIcon from "@mui/icons-material/Payment";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GavelIcon from "@mui/icons-material/Gavel";
import editIcn from "../../../imgs/edit.png";
import trashIcn from "../../../imgs/trash.png";

const AcknowledgementReceiptPage = () => {
  const { surveyId, id, flg } = useParams();
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const [isLoading, setIsLoading] = useState(false);
  const [formContent, setFormContent] = useState({
    date: "",
    receivedFrom: "",
    address: "",
    onAccountOf: "",
    amount: "",
    chequeNo: "",
    drawnOnBank: "",
    inWords: "",
    receivedBy: "",
    clientEmail: "",
    clientName: "",
    adminSign: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isSignCanvas, setSignCanvas] = useState(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };

        values.clientEmail = `${response?.data?.data?.surveyDetail?.email}`;
        values.clientName = `${response?.data?.data?.surveyDetail?.name}`;

        setFormContent(values);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        if (response?.data?.data?.status == "submitted") getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };

          values.clientEmail = `${response?.data?.data?.email}`;
          values.clientName = `${response?.data?.data?.name}`;

          setFormContent(values);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: [],
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage(
          "Acknowledgement Receipt has been added successfully!"
        );
        setOpenSnackbar(true);

        setTimeout(() => {
          navigate(-1);
          setIsLoading(false);
        }, 1000);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const updateContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: [],
      removedMediaKeys: [],
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage(
          "Acknowledgement Receipt has been updated successfully!"
        );
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContent(id, surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (flg === "1") getSurvey();
    else getContent();
  }, []);

  const [show, setShow] = useState(false);

  const [isShare, setIsShare] = useState(false);

  const getTargetElement = () => document.getElementById("content-id");

  //
  const shareWithClient = (data) => {
    let ems = [];
    let emsInd = 0;
    data.map((dt) => {
      if (dt.trim().length !== 0) {
        ems[emsInd] = dt;
        emsInd++;
      }
    });

    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: ems,
      formRoute: "acknowledge-receipt",
    };
    sharePreviewLink(body)
      .then(() => {
        setSnackbarMessage(
          "Acknowledgement Receipt has been shared with client successfully!"
        );
        setOpenSnackbar(true);

        setIsLoading(false);

        setIsShare(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode === 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  const printAction = () => {
    setTimeout(() => {
      window.print();
    }, 500);
  };

  const [isVerified, setIsVerified] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit()
      .then((response) => {
        setIsVerified(true);
        setIsEditLoading(false);
      })
      .catch((error) => {
        setIsVerified(false);
        setIsEditLoading(false);
      });
  };

  const [uploadText, setUploadText] = useState("Upload Sign");
  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  const [mediaKeysToRemove, setMediaKeysToRemove] = useState([]);
  //
  const uploadFile = async (file) => {
    setIsLoading(true);

    setUploadText("Uploading...");
    const fd = new FormData();
    fd.append("image", file);

    imageUpload(fd)
      .then((res) => {
        let values = { ...formContent };
        if (values.adminSign?.trim()?.length !== 0) {
          let dlt = [...mediaKeysToRemove];
          dlt.push(values.adminSign);
          setMediaKeysToRemove(dlt);
        }

        values.adminSign = res?.data?.data?.key;
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode === 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setUploadText("Upload Sign");

        setIsLoading(false);
      });
  };

  return (
    <>
    <div className="no-print">
      <MainTemplate>
        <div className="no-print">
          <div className="d-block d-sm-flex align-items-center py-4">
            <div className="d-flex align-items-center ">
              <div
                className="light-blue-color back-bg cursor-pointer"
                onClick={() => navigate(-1)}
              >
                <img  alt=""  src={backArrow} height="24" width="24" />{" "}
              </div>
              <div>
                <Typography variant="h4" className="ps-3 mb-0" sx={{ fontWeight: 800, color: '#1e293b' }}>Acknowledgement Receipt</Typography>
              </div>
            </div>
            <div className="d-flex ms-auto justify-content-center mt-2 mt-sm-0 gap-2">
              {/*Edit Button */}
              {!isEdit && (
                 <Button
                    variant="outlined"
                    startIcon={<EditIcon />}
                    onClick={() => {
                        sendEditRequestToAdmin();
                    }}
                    disabled={isEditLoading}
                     sx={{ 
                        borderRadius: "var(--radius-md)", 
                        textTransform: "none", 
                        fontWeight: 700, 
                        border: "1px solid var(--glass-border)",
                        color: "var(--text-main)",
                        '&:hover': { background: 'var(--bg-color)', borderColor: 'var(--primary-color)' }
                    }}
                >
                    Edit
                </Button>
              )}
              {/*Share Button */}
              {!isEdit && (
                 <Button
                    variant="outlined"
                    startIcon={<ShareIcon />}
                    onClick={() => {
                        setIsShare(true);
                      }}
                      disabled={isLoading}
                       sx={{ 
                        borderRadius: "var(--radius-md)", 
                        textTransform: "none", 
                        fontWeight: 700, 
                        border: "1px solid var(--glass-border)",
                        color: "var(--text-main)",
                        '&:hover': { background: 'var(--bg-color)', borderColor: 'var(--primary-color)' }
                    }}
                  >
                      Share
                  </Button>
              )}

              {/* Cancel button */}
              {isEdit && flg === "2" && (
                 <Button
                    variant="outlined"
                    startIcon={<CancelIcon />}
                     color="error"
                    onClick={() => {
                        getContent();
                        setIsEdit(false);
                    }}
                    disabled={isLoading}
                     sx={{ borderRadius: "var(--radius-md)", textTransform: "none", fontWeight: 700, border: "1px solid" }}
                >
                    Cancel
                </Button>
              )}

              {/* Save Button */}
              {isEdit && (
                 <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => {
                        if (flg === "1") addContent();
                        else updateContent();
                    }}
                    disabled={isLoading}
                     sx={{ 
                        borderRadius: "var(--radius-md)", 
                        textTransform: "none", 
                        fontWeight: 700, 
                        backgroundColor: "var(--primary-color)",
                        boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                        '&:hover': { backgroundColor: 'var(--primary-hover)' }
                    }}
                >
                    Save
                </Button>
              )}

              {/* Download Button */}
              {!isEdit && (
                 <Button
                    variant="contained"
                    startIcon={<PrintIcon />}
                    onClick={() => {
                        if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }
            var tempTitle = document.title;
                        document.title = `Acknowledgement Receipt-${
                        formContent?.clientName
                        }-${moment(new Date()).format("DD.MM.YYYY")}`;

                        printAction();
                        document.title = tempTitle;
                    }}
                    disabled={isLoading}
                     sx={{ 
                        borderRadius: "var(--radius-md)", 
                        textTransform: "none", 
                        fontWeight: 700, 
                        backgroundColor: "var(--text-main)",
                        boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                        '&:hover': { backgroundColor: '#000' }
                    }}
                >
                    Save as PDF
                </Button>
              )}
            </div>
          </div>
          
          <SectionHeader title="Receipt Details" icon={<ReceiptIcon />} />
          <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <div className="contact-detail d-flex mt-4">
            {/* left col */}
            <div
              className={`left-col ${
                !isEdit ? " w-75" : "w-50 pe-5"
              } text-start`}
            >
              <Typography
                variant="body1"
                className="text-start w-100"
                gutterBottom
              >
                <ContactDetailField
                  label="Date"
                  isEdit={isEdit}
                  type="date"
                  wrapperStyle="justify-content-start"
                  minWidth={"150px"}
                  value={formContent?.date}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.date = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Received From"
                  isEdit={isEdit}
                  type="text"
                  wrapperStyle="justify-content-start"
                  minWidth={"150px"}
                  value={formContent?.receivedFrom}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.receivedFrom = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Typography>
            </div>
          </div>
          </PremiumCard>

          <SectionHeader title="Payment Information" icon={<PaymentIcon />} />
          <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          {/*  Address */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex">
                <div>
                  <label
                    htmlFor="packingDate"
                    className="fw-bold"
                    style={{ width: "200px" }}
                  >
                    Address
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text ">
                    {formContent?.address ? formContent?.address : "-"}{" "}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="Address"
                    type="text"
                    label="Address"
                    style="full-border-field"
                    value={formContent?.address}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.address = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr className="my-3" />
          </div>
          {/* / Address */}
          {/*  On Account Of */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex">
                <div>
                  <label
                    htmlFor="packingDate"
                    className="fw-bold"
                    style={{ width: "200px" }}
                  >
                    On Account of
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text ">
                    {formContent?.onAccountOf ? formContent?.onAccountOf : "-"}
                  </span>
                )}
                {isEdit && (
                  <TextArea
                    id="on-account-of"
                    type="text"
                    label="On Account of"
                    style=""
                    value={formContent?.onAccountOf}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.onAccountOf = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                    rows={5}
                  />
                )}
              </div>
            </Typography>
            <hr className="my-3" />
          </div>
          {/* /On Account Of */}
          {/*  Amount */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex">
                <div>
                  <label
                    htmlFor="packingDate"
                    className="fw-bold"
                    style={{ width: "200px" }}
                  >
                    Amount
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text ">
                    {formContent?.amount ? formContent?.amount : "-"}{" "}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="ammount"
                    type="text"
                    label="Amount"
                    style="full-border-field"
                    value={formContent?.amount}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.amount = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr className="my-3" />
          </div>
          {/* /Amount */}
          {/*  Cash/Cheque # */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex">
                <div>
                  <label
                    htmlFor="packingDate"
                    className="fw-bold"
                    style={{ width: "200px" }}
                  >
                    Cash/Cheque #
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text ">
                    {formContent?.chequeNo ? formContent?.chequeNo : "-"}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="cheque-no"
                    type="text"
                    label="Cash/Cheque #"
                    style="full-border-field"
                    value={formContent?.chequeNo}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.chequeNo = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr className="my-3" />
          </div>
          {/* /Cash/Cheque # */}
          {/*  Drawn on Bank */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex">
                <div>
                  <label
                    htmlFor="packingDate"
                    className="fw-bold"
                    style={{ width: "200px" }}
                  >
                    Drawn on Bank
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text ">
                    {formContent?.drawnOnBank ? formContent?.drawnOnBank : "-"}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="drawn-on-bank"
                    type="text"
                    label="Drawn on Bank"
                    style="full-border-field"
                    value={formContent?.drawnOnBank}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.drawnOnBank = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr className="my-3" />
          </div>
          {/* /Drawn on Bank */}
          {/*  In words */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex">
                <div>
                  <label
                    htmlFor="packingDate"
                    className="fw-bold"
                    style={{ width: "200px" }}
                  >
                    In words
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text ">
                    {formContent?.inWords ? formContent?.inWords : "-"}{" "}
                  </span>
                )}
                {isEdit && (
                  <Input
                    id="in-words"
                    type="text"
                    label="In words"
                    style="full-border-field"
                    value={formContent?.inWords}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.inWords = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                  />
                )}
              </div>
            </Typography>
            <hr className="my-3" />
          </div>
          {/* /In words*/}
          {/*  Received By */}
          <div className="mt-5 pe-1 ">
            <Typography variant="body1" className="text-start" gutterBottom>
              <div className="table-text-wrapper mb-2 d-flex">
                <div>
                  <label
                    htmlFor="packingDate"
                    className="fw-bold"
                    style={{ width: "200px" }}
                  >
                    Received By
                  </label>
                </div>
                {!isEdit && (
                  <span className="table-text ">
                    {formContent?.receivedBy ? formContent?.receivedBy : "-"}
                  </span>
                )}
                {isEdit && (
                  <TextArea
                    id="truckNo"
                    type="text"
                    label="Received By"
                    style=""
                    value={formContent?.receivedBy}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.receivedBy = e.target.value;
                      setFormContent(values);
                    }}
                    inline={{ width: "-webkit-fill-available" }}
                    rows={5}
                  />
                )}
              </div>
            </Typography>
            <hr className="mb-10 my-3" />
          </div>
          {/* /Received By*/}
          </PremiumCard>

          {/* snackbar */}
          <Snackbar
            open={openSnackbar}
            autoHideDuration={6000} // Adjust the duration as needed
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              severity={
                snackbarMessage?.includes("successful") ? "success" : "error"
              }
              onClose={handleCloseSnackbar}
            >
              {snackbarMessage}
            </MuiAlert>
          </Snackbar>
          {/* /snackbar */}
        </div>

          
          <SectionHeader title="Approvals" icon={<GavelIcon />} />
          <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <Row className="mt-5 pt-5 pb-5 no-print">
          <div></div>
          <Col sm={6} className="mt-5 pt-5">
            <div
              style={{ height: "90px" }}
              className="d-flex justify-content-center align-items-end"
            >
              {formContent?.adminSign?.trim()?.length == 0 ? (
                <>
                  {isEdit && (
                    <div className="d-flex justify-content-center align-items-end">
                      <label
                        htmlFor="uploadSign"
                        className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                      >
                        {uploadText}
                      </label>
                      <input
                        type="button"
                        hidden
                        id="uploadSign"
                        name="uploadSign"
                        onClick={() => {
                          setSignCanvas(true);
                        }}
                      />
                    </div>
                  )}
                </>
              ) : (
                <div className="d-flex align-items-start">
                  <img
                    alt=""
                    src={`${Bucket}${formContent.adminSign}`}
                    height={80}
                    width={200}
                  />
                  {isEdit && (
                    <>
                      <label
                        htmlFor="editSign"
                        className=" ms-2  d-flex align-items-center justify-content-center cursor-pointer btn p-0"
                      >
                        <img
                          alt=""
                          src={editIcn}
                          height={18}
                          width={18}
                          className="ms-2 cursor-pointer"
                        />
                      </label>
                      <input
                        type="button"
                        hidden
                        id="editSign"
                        name="uploadSign"
                        onClick={() => {
                          setSignCanvas(true);
                        }}
                      />
                      <img
                        alt=""
                        src={trashIcn}
                        height={18}
                        width={18}
                        className="ms-2 cursor-pointer"
                        onClick={() => {
                          let keysToDelete = [...mediaKeysToRemove];
                          keysToDelete.push(formContent.adminSign);
                          setMediaKeysToRemove(keysToDelete);

                          let values = { ...formContent };
                          values.adminSign = "";
                          setFormContent(values);
                        }}
                      />
                    </>
                  )}
                </div>
              )}
            </div>
            <p>{"_______________________________"}</p>
            <p className="my-1">
              <b>{"Shelozon Movers Packers & Logistics Pvt Ltd"}</b>
            </p>

            {""}
            </Col>
          </Row>
        </PremiumCard>

        {isShare && (
          <ShareWithClientsModal
            open={isShare}
            onClose={() => {
              setIsShare(false);
            }}
            onSuccess={(emails) => {
              shareWithClient(emails);
            }}
          />
        )}

        {isVerified && (
          <SuperAdminVerifationModal
            open={isVerified}
            onClose={() => {
              setIsVerified(false);
            }}
            onSuccess={() => {
              setIsEdit(true);
              setIsVerified(false);
            }}
            onError={() => {
              // shareWithClient(emails);
              setSnackbarMessage("Invalid Confirm Pin");
              setOpenSnackbar(true);
            }}
          />
        )}

        {/* Add signature Modal */}
        {isSignCanvas && (
          <MySignatureCanvas
            open={isSignCanvas}
            onClose={() => {
              setSignCanvas(false);
            }}
            onSuccess={(file) => {
              if (!isLoading) uploadFile(file);
            }}
          />
        )}
      </MainTemplate>
    </div>

      <PrintComponent>
        <AcknowledgementReceiptDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>
    </>
  );
};
export default AcknowledgementReceiptPage;
